import { i18nSymbol } from '@/i18n';
import { injectService } from '@/inversify.config';
export default function patentField(i18nKey) {
    const i18n = injectService(i18nSymbol);
    if (i18n.te(`commonPatent.BASIC.${i18nKey}`)) {
        return i18n.t(`commonPatent.BASIC.${i18nKey}`);
    }
    if (i18n.te(`advanceSort.extendFields.${i18nKey}`)) {
        return i18n.t(`advanceSort.extendFields.${i18nKey}`);
    }
    return i18nKey;
}
export function getPatentFieldTip(i18nKey) {
    const i18n = injectService(i18nSymbol);
    if (i18n.te(`FieldManager.BASIC_TIP.${i18nKey}`)) {
        return i18n.t(`FieldManager.BASIC_TIP.${i18nKey}`);
    }
    return '';
}
